module.exports = __webpack_public_path__ + "static/img/logo2-2.e08b3e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/header/logo2-2.png
// module id = UZtB
// module chunks = 81